module.exports = __webpack_public_path__ + "static/media/cronos-power.ae4dfce5.svg";